import React from 'react';
import { string } from 'prop-types';


function SocialMedia({ url, image, alt }) {
  return (
    <li className="socialMedias-item">
      <a href={url} target="_blank" rel="noopener noreferrer">
        <img className="socialMedias-item-image" src={image} alt={alt} />
      </a>
    </li>
  );
}

SocialMedia.propTypes = {
  url: string,
  image: string,
  alt: string,
};

SocialMedia.defaultProps = {
  url: '',
  image: '',
  alt: '',
};


export default SocialMedia;
